var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-FF p-20" },
    [
      _vm.messages && _vm.messages.length > 0
        ? _c(
            "div",
            { staticClass: "income-form-tit" },
            [
              _c(
                "el-alert",
                {
                  staticClass: "customAlert",
                  attrs: { closable: false, type: "warning" },
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _c("div", { staticClass: "iconSize" }, [
                        _vm._v("【操作提示】"),
                      ]),
                      _c("div", { staticClass: "iconSize" }, [
                        _vm._v("一、先填以下关键信息："),
                      ]),
                      _vm._l(_vm.messages, function (message, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "iconSize" },
                          [_vm._v(_vm._s(index + 1) + "." + _vm._s(message))]
                        )
                      }),
                      _c("div", { staticClass: "iconSize" }, [
                        _vm._v("二、确认无误后，再选择「审批/抄送人员」；"),
                      ]),
                      _c("div", { staticClass: "iconSize" }, [
                        _vm._v(
                          "特别注意：若先选人员再修改上述信息，可能导致流程分支变化，需重新调整人员选择！"
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.cc, function (activity, index) {
        return _c(
          "div",
          { key: index },
          [
            _c(
              "van-row",
              [
                _c("van-col", { attrs: { span: "2" } }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-46 h-46 l-h-46 bg-FFDB43 border-50 font-24 cor-33 font-weight-600 text-center",
                    },
                    [_vm._v(_vm._s(index + 1) + " ")]
                  ),
                  _c("div", {
                    staticClass: "line",
                    style:
                      index + 1 != _vm.cc.length
                        ? "background-color: #FFE36D;"
                        : "background-color: #FFFFFF;",
                  }),
                ]),
                _c("van-col", { attrs: { span: "22" } }, [
                  _c("div", { staticClass: "font-30 cor-33 font-weight-600" }, [
                    _vm._v(_vm._s(activity.title)),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "m-t-10 flex",
                      staticStyle: { "justify-content": "space-between" },
                    },
                    [
                      activity.users == null || activity.users.length == 0
                        ? _c("div", { staticClass: "font-30 cor-CC" }, [
                            _vm._v(" " + _vm._s(activity.desc || "") + " "),
                          ])
                        : _c(
                            "div",
                            {
                              staticClass: "flex",
                              on: {
                                click: function ($event) {
                                  return _vm.auditMore(activity)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "w-24 h-24",
                                attrs: { src: `${_vm.image_base_url}/ren.png` },
                              }),
                              activity.users[0].name &&
                              activity.users[0].name.length
                                ? _c(
                                    "div",
                                    { staticClass: "font-28 cor-FFDB43" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            activity.users[0].name.length > 4
                                              ? activity.users[0].name.substring(
                                                  0,
                                                  2
                                                ) + ".."
                                              : activity.users[0].name
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              activity.users.length > 1
                                ? _c("div", { staticClass: "flex m-l-20" }, [
                                    _c("img", {
                                      staticClass: "w-40 h-40",
                                      attrs: {
                                        src: `${_vm.image_base_url}/diandiandian.png`,
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "font-28 cor-FFDB43" },
                                      [_vm._v("更多")]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                      activity.isEdit &&
                      (activity.multiple || 0 === activity.users.length)
                        ? _c(
                            "div",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.addUser(activity)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "w-40 h-40",
                                attrs: {
                                  src: `${_vm.image_base_url}/tianjia.png`,
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          on: { close: _vm.popupClose },
          model: {
            value: _vm.auditPopup,
            callback: function ($$v) {
              _vm.auditPopup = $$v
            },
            expression: "auditPopup",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: `已选择（${_vm.nowNodeAuditUser.length}人）`,
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.auditPopup = false
              },
              "click-right": function ($event) {
                _vm.auditPopup = false
              },
            },
          }),
          _c(
            "div",
            { staticClass: "p-20" },
            [
              _c(
                "draggable",
                {
                  attrs: {
                    disabled: !_vm.selectedNode.isEdit,
                    handle: ".drag-handle",
                    "ghost-class": "ghost",
                    "chosen-class": "chosen",
                    animation: "200",
                  },
                  on: { end: _vm.onDragEnd },
                  model: {
                    value: _vm.nowNodeAuditUser,
                    callback: function ($$v) {
                      _vm.nowNodeAuditUser = $$v
                    },
                    expression: "nowNodeAuditUser",
                  },
                },
                [
                  _c(
                    "transition-group",
                    { attrs: { type: "transition", name: "flip-list" } },
                    _vm._l(_vm.nowNodeAuditUser, function (audit, index) {
                      return _c(
                        "van-row",
                        {
                          key: audit.id,
                          staticClass: "p-10 draggable-item",
                          attrs: { type: "flex", align: "center" },
                        },
                        [
                          _c("van-col", { attrs: { span: 14 } }, [
                            _c(
                              "div",
                              {
                                staticClass: "drag-handle m-r-10 flex",
                                staticStyle: { cursor: "grab" },
                              },
                              [
                                _c("div", { staticClass: "avatar" }, [
                                  _vm._v(_vm._s(audit.name.substring(0, 1))),
                                ]),
                                _c("div", { staticClass: "font-30 m-l-14" }, [
                                  _vm._v(_vm._s(audit.name)),
                                ]),
                              ]
                            ),
                          ]),
                          _c(
                            "van-col",
                            {
                              staticClass: "flex justify-end",
                              staticStyle: { "justify-content": "flex-end" },
                              attrs: { span: 10 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _c("van-button", {
                                    attrs: {
                                      size: "small",
                                      round: "",
                                      color: "#c75450",
                                      text: "移除",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.delAudit(audit)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }